import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsPrimary } from './components/TestimonialsPrimary';
import { PainSection } from './components/PainSection';
import { useCountdown } from './hooks/useCountdown';
import { useDeferredReady } from './hooks/useDeferredReady';

// Everything below the fold is loaded after the first paint so the hero
// never waits on its JS/CSS.
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const UpsellComparison = lazy(() => import('./components/UpsellComparison').then(m => ({
  default: m.UpsellComparison
})));
const TestimonialsSecondary = lazy(() => import('./components/TestimonialsSecondary').then(m => ({
  default: m.TestimonialsSecondary
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const CostOfInactionSection = lazy(() => import('./components/CostOfInactionSection').then(m => ({
  default: m.CostOfInactionSection
})));
const FinalCTASection = lazy(() => import('./components/FinalCTASection').then(m => ({
  default: m.FinalCTASection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  const isReady = useDeferredReady();
  const {
    parts
  } = useCountdown({
    enabled: isReady
  });
  return <div className="w-full bg-cream-100 font-sans antialiased" data-id="element-0" data-mp="swgmhuqk1csa">
      <main className="w-full" data-id="element-1" data-mp="34x1vh8db93d">
        <Hero data-id="element-2" data-mp="38b6yx8f1wei" />
        <SocialProofBar data-id="element-3" data-mp="3ud1gzdqblwcq" />
        <TestimonialsPrimary data-id="element-4" data-mp="3udkr489qbgg7" />
        <PainSection data-id="element-5" data-mp="3ucjc5sple9t7" />

        <Suspense fallback={<div className="min-h-[60vh] w-full bg-cream-100" data-id="element-7" data-mp="d4e4tqw8j8vn" />} data-id="element-6" data-mp="3uf5gzkl3mb7q">
          <ProductSection data-id="element-8" data-mp="d2l9v8uzid3h" />
          <BonusSection data-id="element-9" data-mp="85l0op2u8u85" />
          <UrgencySection parts={parts} data-id="element-10" data-mp="85bcn71csx53" />
          <PricingSection data-id="element-11" data-mp="86cqfj9r7xqi" />
          <UpsellComparison data-id="element-12" data-mp="3gleaym6kt9gr" />
          <TestimonialsSecondary data-id="element-13" data-mp="3gkl6xsz04y2b" />
          <GuaranteeSection data-id="element-14" data-mp="3glny8208l2ir" />
          <CostOfInactionSection data-id="element-15" data-mp="3bmbg1ukb8jmi" />
          <FinalCTASection parts={parts} data-id="element-16" data-mp="3bncqbwti5236" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-17" data-mp="3qaxu7sy7b5c5">
        <Footer data-id="element-18" data-mp="3qbzgktko3e96" />
        {isReady && <SocialProofPopup data-id="element-19" data-mp="3qdai0mqn49x4" />}
      </Suspense>
    </div>;
}